import { ApiAssignment } from '../api/api-assignments.model';

export interface AppAssignment {
    companyName: string;
    tourInventoryId: number;
    tourInventoryTime: TourInventoryTime;
    tourInventoryAllocatedSeats: number;
    tourTime: string;
    shipName: string;
    tourName: string;
    preLim: number;
    final: number | null;
    actualTotal: number | null;
    actualAdults: number | null;
    actualChildren: number | null;
    cruiseLineEscorts: number | null;
    transportation: string | null;
    guideName: string | null;
    guideFullName: string | null;
    dockName: string | null;
    dTDAssignmentGuideVariableId: string | null; // TODO: verify this type
    dTDAssignmentGuideId: number | null; // TODO: verify this type
    payingAdditionalGuests: number;
    specialNotes: string | null;
    bookingFName: string | null;
    bookingLName: string | null;
    bookingAdults: number;
    bookingChildren: number;
    bookingEmail: string | null;
    bookingPhone: string | null;
    partnerId: number | null;
    totalBooked: number | null;
    isClosed: boolean;
    isOpen: boolean;
    mobleViewColumn: null; // TODO: verify this type
    total: number | null;
}

interface TourInventoryTime {
    hours: number;
    minutes: number;
    seconds: number;
    milliseconds: number;
    ticks: number;
    days: number;
    totalDays: number;
    totalHours: number;
    totalMilliseconds: number;
    totalMinutes: number;
    totalSeconds: number;
}

export function fromApiAssignments(
    assignments: ApiAssignment[]
): AppAssignment[] {
    return assignments.map((assignment) => fromApiAssignment(assignment));
}

export function fromApiAssignment(assignment: ApiAssignment): AppAssignment {
    const updatedAssignment = {
        ...assignment,
        tourInventoryId: assignment.tourInventoryID,
    };
    delete (updatedAssignment as { tourInventoryID?: number }).tourInventoryID;
    return updatedAssignment;
}
